/* ============================================
   Anchor scroll
   Défilement interne à la page pour les liens portant [data-anchor-scroll].

   Pourquoi ne pas laisser le saut d'ancre natif faire le travail :
   1. `body { overflow-x: hidden }` (global.css) fait du body un conteneur de défilement,
      ce qui rend le saut natif erratique et différé sur certains navigateurs.
   2. Le header est en `position: fixed` : sans compensation, il recouvre le haut de la cible.

   Le défilement est animé (`SCROLL_BEHAVIOR`), sauf si l'utilisateur a demandé une réduction
   des animations — auquel cas il redevient instantané.
   ============================================ */

(function () {
  'use strict';

  var SCROLL_BEHAVIOR = 'smooth';
  var EXTRA_GAP = 16;

  /*
    `--header-height` est posée par sections-header.js via un ResizeObserver, mais elle peut être
    absente au moment du clic (observer pas encore déclenché, header masqué, section rechargée).
    On mesure alors le header directement : c'est la seule valeur fiable en toutes circonstances.
  */
  function headerOffset() {
    var header = document.querySelector('.shopify-section--header');
    if (header && getComputedStyle(header).position === 'fixed') {
      return header.getBoundingClientRect().height + EXTRA_GAP;
    }

    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var height = parseFloat(raw);
    return (isNaN(height) ? 0 : height) + EXTRA_GAP;
  }

  function scrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : SCROLL_BEHAVIOR;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest ? event.target.closest('[data-anchor-scroll]') : null;
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;

    var target = document.getElementById(href.slice(1));
    if (!target) return;

    event.preventDefault();

    var top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: scrollBehavior() });

    // Met l'URL à jour sans déclencher le saut natif du navigateur
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', href);
    }

    // Garde la cible atteignable au clavier sans la cerner d'un contour permanent
    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }
    target.focus({ preventScroll: true });
  });
})();
